import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Card, CardContent } from '@mui/material';
import Dropdown from '../../../components/Dropdown';
import useThemeStyles from '../../../hooks/useThemeStyles';

const PreferencesCard = ({ theme, onThemeChange }) => {
  const { colors, components } = useThemeStyles();

  const cardStyle = {
    ...components.card,
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  };

  const handleChange = (e) => {
    const newTheme = e.target.value;
    onThemeChange(newTheme);
  };

  return (
    <Card id="preferences-card" style={cardStyle}>
      <CardContent id="preferences-content" sx={{ padding: 3 }}>
        <Box
          id="preferences-header"
          sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 2 }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Preferences
          </Typography>
        </Box>
        <Box id="preferences-form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Dropdown
            id="theme-dropdown"
            label="Theme"
            value={theme}
            onChange={handleChange}
            options={[
              { value: 'light', label: 'Light', icon: '☀️' },
              { value: 'dark', label: 'Dark', icon: '🌙' },
            ]}
          />
          <Typography
            id="theme-description"
            variant="body2"
            sx={{ fontSize: '0.875rem', color: colors.text.secondary }}
          >
            Theme applies to the entire PlotWyze app and syncs across your devices.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

PreferencesCard.propTypes = {
  theme: PropTypes.string.isRequired,
  onThemeChange: PropTypes.func.isRequired,
};

export default PreferencesCard;
